import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import FilterList from '@mui/icons-material/FilterList';
import CircularProgress from '@mui/material/CircularProgress';

type RequestStatusCountProps = {
  color: string;
  count: number;
  dataTestId?: string;
  isActive: boolean;
  isLoading?: boolean;
  onClick?: () => void;
  text: string;
};

export function RequestStatusCount(props: Readonly<RequestStatusCountProps>) {
  return (
    <Stack
      alignItems={'center'}
      border={'1px solid #CCCCCC'}
      borderRadius={'4px'}
      data-testid={props.dataTestId}
      direction="row"
      height={'5rem'}
      minWidth={'250px'}
      onClick={props.onClick}
      p={2}
      sx={{
        borderColor: (theme) =>
          props.isActive === true ? theme.palette.primary.main : '#CCCCCC',
        boxShadow: (theme) =>
          props.isActive === true
            ? `0 0 0px 1px ${theme.palette.primary.main}`
            : 'none',
        cursor: 'pointer',
      }}
    >
      <Box
        height="2.8rem"
        sx={{
          backgroundColor: props.color,
        }}
        width="4px"
      />
      {props.isLoading ? (
        <CircularProgress size={30} sx={{ mx: '10px' }} />
      ) : (
        <Stack direction="column" flex={1} marginLeft={1}>
          <Typography
            data-testid={`${props.dataTestId}-count`}
            fontSize="1.5rem"
            fontWeight={'bold'}
          >
            {props.count}
          </Typography>

          <Typography
            data-testid={`${props.dataTestId}-text`}
            fontSize="0.75rem"
            lineHeight={'0.75rem'}
            mt={0.5}
          >
            {props.text}
          </Typography>
        </Stack>
      )}
      <FilterList style={{ alignSelf: 'stretch', fontSize: '1.125rem' }} />
    </Stack>
  );
}
